const InfoTextBox = (props) => {
  const { children, className } = props;
  return (
    <div className={`container ${className}`}>
      <div className="notification content ">
        <span className="material-icons info orange">info</span>
        {children}
      </div>
    </div>
  );
};

export default InfoTextBox;